class NextAppointmentApi {
    constructor(DoclrHttp, praktijkContext, userContext, AppConfigService) {
        'ngInject';
        this.praktijkContext = praktijkContext;
        this.userContext = userContext;
        this.DoclrHttp = DoclrHttp;
        this.AppConfigService = AppConfigService;
    }

    searchNextAppointment(nextAppointmentCriteria) {
        nextAppointmentCriteria.partyId = this.praktijkContext.id;
        return this.DoclrHttp.post(this.AppConfigService.getApiUrl() + this._getUrl(), nextAppointmentCriteria);
    }

    _getUrl(){
       return `${this._getType()}/apiv0/praktijk/${this.praktijkContext.id}/volgende-afspraak`;
    }

    _getType() {
        return (this.userContext.isAdminApp() ) ? '/' : '/public';
    }
}

(function () {
    'use strict';

    angular.module('doclr.components')
        .service('NextAppointmentApi', NextAppointmentApi)
})();